import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, MapPin, Mail, Phone } from "lucide-react";
import { FullLogo } from "./Logo";
import { useApp } from "../context/AppContext";

const WHATSAPP = "https://wa.me/213661413311?text=Bonjour%20Ssuq";

const Footer = () => {
  const { t, lang } = useApp();
  return (
    <footer className="bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-5 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="inline-flex bg-white rounded-2xl p-4 shadow-lg">
            <FullLogo className="h-24 w-auto" />
          </div>
          <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-xs">{t("footer_tag")}</p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-orange mb-4">{t("footer_nav")}</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/catalogue" className="hover:text-white transition-colors">{t("nav_catalogue")}</Link></li>
            <li><Link to="/inscription" className="hover:text-white transition-colors">{t("nav_compte")}</Link></li>
            <li><Link to="/connexion" className="hover:text-white transition-colors">{t("nav_connexion")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-orange mb-4">{t("footer_legal")}</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><span className="hover:text-white transition-colors cursor-pointer">CGV</span></li>
            <li><span className="hover:text-white transition-colors cursor-pointer">Confidentialité</span></li>
            <li><span className="hover:text-white transition-colors cursor-pointer">Mentions légales</span></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-orange mb-4">{t("footer_contact")}</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><MapPin size={16} className="text-orange shrink-0" /> Alger, Algérie</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-orange shrink-0" /> +213 661 41 33 11</li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-orange shrink-0" /> <a href="mailto:pro@ssuq.pro" className="hover:text-orange transition">pro@ssuq.pro</a></li>
          </ul>
          <a href={WHATSAPP} target="_blank" rel="noreferrer"
            className="mt-4 inline-flex items-center gap-2 bg-[#25D366] text-white font-display text-sm font-semibold rounded-full px-4 py-2 hover:brightness-95 transition">
            <MessageCircle size={16} /> {t("whatsapp")}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 py-5 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {lang === "ar" ? "سوق" : "Ssuq"}. {t("footer_rights")}</span>
          <span>Alger · Oran · Constantine · Annaba · Sétif</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
